module.exports = __webpack_public_path__ + "static/media/placeholder.1eb7fff2.jpg";